/**
 * assets/card-product-custom.js
 *
 * Handles:
 *  1. Variant pill switching — instant price update (zero fetches)
 *  2. AJAX Add to Cart → refreshes and opens Dawn's native cart drawer
 *
 * Install: add ONE line in layout/theme.liquid just before </body>:
 *   <script src="{{ 'card-product-custom.js' | asset_url }}" defer></script>
 */

(function () {
  'use strict';

  /* ─────────────────────────────────────────────────────────────
     MONEY FORMAT
  ───────────────────────────────────────────────────────────── */
  var moneyFormat = (function () {
    var el = document.getElementById('pcc-money-format');
    return el ? el.content : '₹{{amount}}';
  })();

  function formatMoney(paise) {
    var amount = (paise / 100).toFixed(2).replace(/\.00$/, '');
    return moneyFormat
      .replace('{{amount}}', amount)
      .replace('{{amount_with_comma_separator}}', amount)
      .replace('{{amount_no_decimals}}', Math.round(paise / 100))
      .replace('{{amount_no_decimals_with_comma_separator}}', Math.round(paise / 100));
  }

  /* ─────────────────────────────────────────────────────────────
     1. VARIANT PILL SWITCHING
  ───────────────────────────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.pcc-v-btn');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    if (btn.classList.contains('pcc-v-btn--na')) return;

    var card = btn.closest('[data-product-id]');
    if (!card) return;

    var productId    = card.dataset.productId;
    var sectionId    = card.dataset.sectionId;
    var variantId    = btn.dataset.variantId;
    var pricePaise   = parseInt(btn.dataset.pricePaise,   10) || 0;
    var comparePaise = parseInt(btn.dataset.comparePaise, 10) || 0;
    var available    = btn.dataset.available === 'true';

    card.querySelectorAll('.pcc-v-btn').forEach(function (b) {
      b.classList.remove('pcc-v-btn--active');
      b.setAttribute('aria-pressed', 'false');
    });
    btn.classList.add('pcc-v-btn--active');
    btn.setAttribute('aria-pressed', 'true');

    var priceWrapper = document.getElementById('pcc-price-' + productId + '-' + sectionId);
    if (priceWrapper) {
      var hasSale  = comparePaise > pricePaise;
      var regBlock = priceWrapper.querySelector('.price__regular');
      var saleBlock= priceWrapper.querySelector('.price__sale');
      var regItem  = priceWrapper.querySelector('.price__regular .price-item--regular');
      var saleItem = priceWrapper.querySelector('.price__sale .price-item--sale');
      var oldItem  = priceWrapper.querySelector('.price__sale .price-item--regular');

      if (hasSale) {
        if (regBlock)  regBlock.style.display  = 'none';
        if (saleBlock) saleBlock.style.display = '';
        if (saleItem)  saleItem.textContent    = formatMoney(pricePaise);
        if (oldItem)   oldItem.textContent     = formatMoney(comparePaise);
      } else {
        if (regBlock)  regBlock.style.display  = '';
        if (saleBlock) saleBlock.style.display = 'none';
        if (regItem)   regItem.textContent     = formatMoney(pricePaise);
      }
    }

    var atcBtn = document.getElementById('pcc-atc-' + productId + '-' + sectionId);
    if (atcBtn) {
      atcBtn.dataset.variantId = variantId;
      atcBtn.disabled = !available;
      var t = atcBtn.querySelector('.pcc-atc__text');
      if (t) t.textContent = available ? 'Add to cart' : 'Sold out';
    }
  });

  /* ─────────────────────────────────────────────────────────────
     2. AJAX ADD TO CART
  ───────────────────────────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.pcc-atc');
    if (!btn || btn.disabled) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    var vid = parseInt(btn.dataset.variantId, 10);
    if (!vid || vid <= 0) {
      console.error('[PCC] ATC: missing or invalid variantId on button:', btn);
      return;
    }

    btn.classList.add('pcc-atc--loading');
    btn.disabled = true;

    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: vid, quantity: 1 })
    })
    .then(function (res) {
      if (!res.ok) return res.json().then(function (d) {
        throw new Error(d.description || d.message || 'Status ' + res.status);
      });
      return res.json();
    })
    .then(function () {
      btn.classList.remove('pcc-atc--loading');
      btn.classList.add('pcc-atc--added');
      btn.disabled = false;
      var t = btn.querySelector('.pcc-atc__text');
      if (t) t.textContent = '✓ Added!';
      setTimeout(function () {
        btn.classList.remove('pcc-atc--added');
        if (t) t.textContent = 'Add to cart';
      }, 2200);

      openAndRefreshDawnDrawer();
    })
    .catch(function (err) {
      btn.classList.remove('pcc-atc--loading');
      btn.disabled = false;
      console.error('[PCC] Cart add failed — variant:', vid, '— error:', err.message);
      var t = btn.querySelector('.pcc-atc__text');
      if (t) {
        var prev   = t.textContent;
        var errMsg = err.message && err.message.length < 60 ? err.message : 'Try again';
        t.textContent = errMsg;
        setTimeout(function () { t.textContent = prev; }, 3000);
      }
    });
  });

  /* ─────────────────────────────────────────────────────────────
     OPEN + REFRESH DAWN'S DRAWER
     
     Root cause of the invisible-drawer bug:
     Dawn's <cart-drawer> is a Web Component. Its connectedCallback
     and internal event listeners run once on page load. Swapping
     innerHTML fragments mid-session leaves the component's JS state
     out of sync with the DOM, so the drawer "opens" but renders blank
     or stays invisible until a full page reload re-initialises it.

     Fix: fetch the full rendered section HTML, replace the ENTIRE
     <cart-drawer> element in the DOM (not just its children), then
     re-execute any <script> tags that Dawn ships inside the section
     so the Web Component re-registers itself. After that, call
     drawerEl.open() on the fresh element.
  ───────────────────────────────────────────────────────────── */
  function openAndRefreshDawnDrawer() {
    fetch('/?sections=cart-drawer', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      var html = data['cart-drawer'];
      if (!html) { fallbackOpen(); return; }

      /* Parse the full section HTML */
      var parser   = new DOMParser();
      var freshDoc = parser.parseFromString(html, 'text/html');

      /* ── Strategy: replace the whole <cart-drawer> element ── */
      var freshDrawer = freshDoc.querySelector('cart-drawer');
      var liveDrawer  = document.querySelector('cart-drawer');

      if (!freshDrawer || !liveDrawer) { fallbackOpen(); return; }

      /* Preserve the live element's open/active classes if any */
      var wasOpen = liveDrawer.classList.contains('active') ||
                    liveDrawer.hasAttribute('open');

      /* Replace the element entirely so Dawn's connectedCallback fires again */
      liveDrawer.replaceWith(freshDrawer.cloneNode(true));

      /* Re-run any <script> tags that Dawn ships inside the section.
         cloneNode does NOT copy script execution — we must do this manually. */
      var newLiveDrawer = document.querySelector('cart-drawer');
      if (newLiveDrawer) {
        newLiveDrawer.querySelectorAll('script').forEach(function (oldScript) {
          var s = document.createElement('script');
          Array.from(oldScript.attributes).forEach(function (a) {
            s.setAttribute(a.name, a.value);
          });
          s.textContent = oldScript.textContent;
          oldScript.parentNode.replaceChild(s, oldScript);
        });
      }

      /* Update header count bubble */
      updateHeaderCount();

      /* Notify any shipping-bar listeners */
      document.dispatchEvent(new CustomEvent('pcc:cart-updated'));

      /* Open the drawer — use a short delay so the Web Component's
         connectedCallback has time to finish registering its internals */
      setTimeout(function () {
        var drawerEl = document.querySelector('cart-drawer');
        if (!drawerEl) return;

        if (typeof drawerEl.open === 'function') {
          drawerEl.open();
        } else {
          /* Dawn versions that use a plain div toggle */
          var inner = document.getElementById('CartDrawer');
          if (inner) inner.classList.add('active');
          /* Try dispatching Dawn's own event as a fallback */
          document.dispatchEvent(new CustomEvent('cart-drawer:open'));
        }
      }, 50);
    })
    .catch(function (err) {
      console.error('[PCC] Drawer refresh failed:', err);
      fallbackOpen();
    });
  }

  /* Last-resort: open whatever is already in the DOM */
  function fallbackOpen() {
    var drawerEl = document.querySelector('cart-drawer');
    if (drawerEl && typeof drawerEl.open === 'function') {
      drawerEl.open();
      return;
    }
    var inner = document.getElementById('CartDrawer');
    if (inner) { inner.classList.add('active'); return; }
    window.location.href = '/cart';
  }

  /* ─────────────────────────────────────────────────────────────
     HEADER CART COUNT BUBBLE
  ───────────────────────────────────────────────────────────── */
  function updateHeaderCount() {
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var count = cart.item_count;
      document.querySelectorAll('.cart-count-bubble').forEach(function (el) {
        var span = el.querySelector('[aria-hidden="true"]');
        if (span) span.textContent = count;
        el.style.display = count > 0 ? '' : 'none';
      });
      document.dispatchEvent(new CustomEvent('pcc:cart-total', { detail: { total: cart.total_price } }));
    })
    .catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', updateHeaderCount);

})();